import { GridRows as VisxGridRows } from '@visx/grid';
import { AllGridRowsProps } from '@visx/grid/lib/grids/GridRows';

import { GridLines } from './GridLines.js';
import { shouldHighlightZeroLine } from './utils/should-highlight-zero-line.js';
import type { AnyScale } from '../../types/scales.js';
import { isBandScale } from '../../utils/detect-scale.js';

export type GridRowsProps = {
  highlightZeroLine?: boolean;
  ticks?: number[];
} & AllGridRowsProps<AnyScale>;

export const GridRows = ({
  scale,
  highlightZeroLine = true,
  ticks,
  ...restProps
}: GridRowsProps) => {
  if (ticks) {
    const typedScale = scale as (value: number) => number | undefined;
    const lines = ticks.map((tick, index) => ({
      from: { x: 0, y: Math.max(0, typedScale(tick) ?? 0) },
      to: { x: restProps.width, y: Math.max(0, typedScale(tick) ?? 0) },
      index,
    }));
    return (
      <GridLines
        lines={lines}
        highlightAccessor={(from, to) =>
          highlightZeroLine &&
          !isBandScale(scale) &&
          shouldHighlightZeroLine(from, to, scale)
        }
      />
    );
  }

  return (
    <VisxGridRows scale={scale} {...restProps}>
      {({ lines }) => (
        <GridLines
          lines={lines}
          highlightAccessor={(from, to) =>
            highlightZeroLine &&
            !isBandScale(scale) &&
            shouldHighlightZeroLine(from, to, scale)
          }
        />
      )}
    </VisxGridRows>
  );
};
